// extracted by mini-css-extract-plugin
export var banner = "_2-0";
export var icon = "_2-1";
export var message = "_2-2";